// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1m-2";
export var blackBorderOnHover = "_1m-7";
export var cell = "_1m-6";
export var cellContainer = "_1m-3";
export var checked = "_1m-8";
export var disabled = "_1m-5";
export var featuredIconCellContainer = "_1m-9";
export var featuredIconTextContainer = "_1m-b";
export var featuredIconWrapper = "_1m-a";
export var noBorder = "_1m-c";
export var orangeSelectedRow = "_4h-3";
export var overflowableText = "_1m-0";
export var overflowableTextContainer = "_1m-1";
export var row = "_1n-0";
export var rowCheckboxCell = "_1m-4";
export var selectableTable = "_4h-2";